import React from 'react';
import Header from './components/Header';
import AllTab from './containers/AllTab';
import EasyPayTab from './containers/EasyPayTab';
import TransactionsTab from './containers/TransactionsTab';
import { useSearchParams, useUpdateSearchParams } from 'hooks';
import BuyerTransactionsFilter from '../TransactionsList/components/BuyerTransactionsFilter';
import { useGetCardBuyerTransactionsQuery } from 'services/api/transactions';

const TransactionsListV2 = () => {
  const params = useSearchParams();
  const currentTab = params.get('active_tab') ?? '';
  const updateSearchParams = useUpdateSearchParams();

  const { data: cardCheck } = useGetCardBuyerTransactionsQuery({ limit: 1, offset: 1 });
  const showCardTab = (cardCheck?.count ?? 0) > 0;

  const changeTab = (tab: string) => {
    updateSearchParams({ active_tab: tab });
  };

  return (
    <div>
      <Header currentTab={currentTab} changeTab={changeTab} showCardTab={showCardTab} />
      <div className="pageWrapper">
        <BuyerTransactionsFilter key={currentTab} currentTab={currentTab} />
        <div style={{ marginTop: 16 }} />
        {(currentTab === '' || currentTab === 'all') && <AllTab />}
        {currentTab === 'transactions' && <TransactionsTab />}
        {currentTab === 'easy_pay' && <EasyPayTab />}
      </div>
    </div>
  );
};

export default TransactionsListV2;
